import React from 'react'
import {SideShadow} from 'components/Accommodation/AccommodationView/Mobile/styles'
import {
  ReviewsTrackClick,
  SelectedElementType
} from 'components/Accommodation/DateGuestInput/ReviewsTrackClick'
import {Swiper} from 'components/Swiper'

import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {HorizontalScroll} from '@daedalus/atlas/helpers/HorizontalScroll'
import {Entity} from '@daedalus/core/src/analytics/types/Events'
import {ReviewRating} from '@daedalus/shared/src/search/ReviewRating'
import {ReviewSentiments} from '@daedalus/shared/src/search/ReviewSentiments'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'

import {ReviewSummaryLoading} from './ReviewSummaryLoading'
import {
  ReviewRatingButton,
  ReviewRatingWrapper,
  ReviewSummaryWrapper,
  SentimentTagsWrapper,
  Wrapper
} from './styles'

interface Props {
  hotel?: ContentHotel
  onReviewSummaryClick: () => void
}

export const ReviewSummary: React.FC<Props> = ({
  onReviewSummaryClick,
  hotel
}) => {
  const {isMobile} = useDeviceLayout()

  const reviewRating = hotel?.guestRating?.overall

  // Show review summary loading
  if (!hotel) return <ReviewSummaryLoading />

  // Hide this section when we don't have review rating
  if (!reviewRating) return null

  if (isMobile) {
    return (
      <ReviewSummaryWrapper>
        <ReviewRatingButton onClick={onReviewSummaryClick}>
          <SentimentTagsWrapper>
            <HorizontalScroll columnGap="s300">
              <ReviewRatingWrapper>
                <ReviewRating
                  underlineSubLabel
                  rating={reviewRating}
                  totalRatingCount={hotel.reviewCount}
                  dataId="ReviewRatingSummary"
                  hotelId={hotel.objectID}
                />
              </ReviewRatingWrapper>
              {hotel.sentiments?.length > 0 && (
                <ReviewsTrackClick
                  dataId="sentiments-subsection"
                  element={SelectedElementType.Sentiment}
                  entity={Entity.HotelDetailsReviewSummary}
                >
                  <ReviewSentiments
                    sentiments={hotel.sentiments}
                    hasResetTagSpacing={false}
                  />
                </ReviewsTrackClick>
              )}
            </HorizontalScroll>
          </SentimentTagsWrapper>
          <SideShadow side="end" />
        </ReviewRatingButton>
      </ReviewSummaryWrapper>
    )
  }

  return (
    <div style={{overflow: 'hidden', width: '100%'}}>
      <Swiper gap="s300" right={0} left={0} shadowWidth={60}>
        <Wrapper>
          <ReviewRatingWrapper>
            <ReviewRatingButton onClick={onReviewSummaryClick}>
              <ReviewRating
                underlineSubLabel
                rating={reviewRating}
                totalRatingCount={hotel.reviewCount}
                dataId="ReviewRatingSummary"
                hotelId={hotel.objectID}
              />
            </ReviewRatingButton>
          </ReviewRatingWrapper>
          {hotel.sentiments?.length > 0 && (
            <ReviewsTrackClick
              dataId="sentiments-subsection"
              element={SelectedElementType.Sentiment}
              entity={Entity.HotelDetailsReviewSummary}
            >
              <ReviewSentiments
                sentiments={hotel.sentiments}
                hasResetTagSpacing={false}
                variant="slider"
              />
            </ReviewsTrackClick>
          )}
        </Wrapper>
      </Swiper>
    </div>
  )
}
